"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var en_CA_json_1 = __importDefault(require("../i18n/en-CA.json"));
var en_GB_json_1 = __importDefault(require("../i18n/en-GB.json"));
var en_US_json_1 = __importDefault(require("../i18n/en-US.json"));
var es_US_json_1 = __importDefault(require("../i18n/es-US.json"));
var fr_CA_json_1 = __importDefault(require("../i18n/fr-CA.json"));
var fr_FR_json_1 = __importDefault(require("../i18n/fr-FR.json"));
var rxjs_1 = require("rxjs");
/** An observable that emits the currently-configured culture for the user. */
exports.currentUserCulture$ = new rxjs_1.BehaviorSubject('en-US');
function configureTranslation(translate, intlService) {
    translate.setDefaultLang('en-US');
    translate.use('en-US');
    translate.setTranslation('en-CA', en_CA_json_1.default);
    translate.setTranslation('en-GB', en_GB_json_1.default);
    translate.setTranslation('en-US', en_US_json_1.default);
    translate.setTranslation('es-US', es_US_json_1.default);
    translate.setTranslation('fr-CA', fr_CA_json_1.default);
    translate.setTranslation('fr-FR', fr_FR_json_1.default);
    // Update angular-translate's culture when the current user culture changes
    exports.currentUserCulture$.subscribe(function (cultureName) {
        translate.use(cultureName);
        intlService.localeId = cultureName;
    });
}
exports.configureTranslation = configureTranslation;
